<template>
	<transition name="scroll">
		<div
			v-if="scrollY > 100"
			class="iv2-home__pagetop-bar position-fixed d-none d-xl-block text-center"
			@click="scrollTop"
		>
			<span class="iv2-home__pagetop-bar-text">Page top</span>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			scrollY: 0
		};
	},

	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll() {
			this.scrollY = window.scrollY;
		},

		scrollTop: function() {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		}
	}
};
</script>

<style lang="scss">
.iv2-home__pagetop-bar {
	color: #5f4d42;
	right: 33px;
	bottom: 0;
	font-size: 20px;
	font-weight: 400;
	letter-spacing: 0.5px;
	height: 160px;
	width: 115px;
	z-index: 5;
	cursor: pointer;

	&::before {
		content: "";
		width: 15px;
		height: 15px;
		border-top: 1px solid;
		border-left: 1px solid;

		position: absolute;
		left: 50%;
		top: 50%;
		// bottom: 68px;

		transform: translateY(calc(-50% + 4px)) translateX(-50%) rotate(45deg);
		-webkit-transform: translateY(calc(-50% + 4px)) translateX(-50%)
			rotate(45deg);
	}

	&::after {
		content: "";

		border-left: 1px solid #5f4d42;
		height: 85px;
		width: 1px;
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translateX(-50%);
		-webkit-transform: translateX(-50%);
	}

	&.scroll-enter-active,
	&.scroll-leave-active {
		transition: all 1s ease;
	}

	&.scroll-enter,
	&.scroll-leave-to {
		transform: translateY(150px) !important;
		opacity: 0;
	}
}
</style>